module.exports = __webpack_public_path__ + "img/alljobs-welcome.63457fda.png";